import { useEffect } from "react";
import { useExecution } from "@/store/executionStore";

/** Advances client-initiated sandbox simulations (the only executions tick()
 *  touches) so test runs progress visibly. Real executions come from the API. */
export function useExecutionHeartbeat() {
  const tick = useExecution((s) => s.tick);
  useEffect(() => {
    const id = setInterval(() => tick(), 3600);
    return () => clearInterval(id);
  }, [tick]);
}
